import { OrderingData } from "./ordering-data";

export class PaginationData {
    rowsPerPage: number = 10;
    pageNumber: number = 1;
}
